import { useCallback } from 'react';
import { CronosEthereumTransferType } from '@types';
import { utils } from 'ethers';

export interface UseCalculateGasFeeInEtherConfig {
  cronosPoolGasLimit: number;
  cronosWarpGasLimit: number;
}

function useCalculateGasFeeInEther({
  cronosPoolGasLimit,
  cronosWarpGasLimit,
}: UseCalculateGasFeeInEtherConfig): (
  transferType: CronosEthereumTransferType,
  gasPrice: number
) => string {
  return useCallback(
    (transferType: CronosEthereumTransferType, gasPrice: number): string => {
      function getGasLimit(transferType: CronosEthereumTransferType): number {
        if (transferType == CronosEthereumTransferType.CronosPool) {
          return cronosPoolGasLimit;
        }

        return cronosWarpGasLimit;
      }

      const gasFeeInGwei = utils
        .parseUnits(`${gasPrice}`, 'gwei')
        .mul(getGasLimit(transferType));

      return utils.formatEther(gasFeeInGwei);
    },
    [cronosPoolGasLimit, cronosWarpGasLimit]
  );
}

export default useCalculateGasFeeInEther;
